export const DISPUTE_REASONS_URL = '/settings/dispute-reasons'
export const DISPUTE_REASON_API = '/api/internal/dispute-reason'

export const DISPUTE_REASONS_BREADCRUMBS = [
  { title: 'Настройки', path: '/settings' },
  { title: 'Причины диспута', path: DISPUTE_REASONS_URL },
]
